module.exports = __webpack_public_path__ + "cloud-app.1rrmFGFD.svg";